import {QuoteForm, QuoteTypes} from "api/quote";
import {Form} from "pages/RateQuoteBind/RatePanel";
import HabitationalLocationsForm from "../shared/HabitationalLocationForm";
import AcordUpload from "../shared/AcordUpload";

export default function other(quoteForm: QuoteForm): Form {
  return {
    sections: {
      "Risk Location": (
        <HabitationalLocationsForm
          locations={quoteForm.locations}
          quoteId={`${quoteForm.quote_id}`}
          quoteType={QuoteTypes.OTHER}
        />
      ),
      "Acord Application": (
        <AcordUpload quoteId={`${quoteForm.quote_id}`} />
      ),
    },
    "Underwriting Questions": <div></div>,
  };
}
